import diff, { orderIndependentDiff } from 'deep-diff';

export const deepDiffWithIgnores = <T, S>(lhs: T, rhs: S, ignores?: string[]): diff.Diff<T, S>[] => {
  const keys = ignores ? ['__typename', ...ignores] : ['__typename'];
  const difference = diff(lhs, rhs, (path, key) => {
    return keys.includes(key);
  });
  return difference?.length ? difference : [];
};

export const orderIndependentDeepDiffWithIgnores = <T, S>(lhs: T, rhs: S, ignores?: string[]): diff.Diff<T, S>[] => {
  const keys = ignores ? ['__typename', ...ignores] : ['__typename'];
  const difference = orderIndependentDiff(lhs, rhs, (path, key) => {
    return keys.includes(key);
  });
  return difference?.length ? difference : [];
};
